"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PtoBalanceCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const TimeAttendance_1 = __importDefault(require("../api/TimeAttendance"));
const UserContext_1 = require("../contexts/UserContext");
const Card_1 = __importDefault(require("../components/Card"));
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const Loading_1 = __importDefault(require("../components/Loading"));
const TableHeader_1 = __importDefault(require("../components/TableHeader"));
const Button_1 = __importDefault(require("../components/Button"));
const List_1 = __importDefault(require("../components/List"));
const react_i18next_1 = require("react-i18next");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    return react_native_1.StyleSheet.create({
        row: {
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'center',
            paddingVertical: 16
        },
        label: {
            color: THEME.TextLight,
            fontSize: 16,
            textAlign: 'center'
        },
        value: {
            color: THEME.Text,
            fontSize: 16,
            textAlign: 'center'
        },
        valueSub: {
            color: THEME.Text + '80',
            fontSize: 14,
            textAlign: 'center'
        }
    });
};
const useMobileStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    return react_native_1.StyleSheet.create({
        mobilePTONameContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            paddingVertical: 14,
        },
        mobilePTOName: {
            fontSize: 14,
            fontWeight: '400',
            textAlign: 'left',
        },
        mobilePTOTagText: {
            fontSize: 12,
            color: THEME.SmokeWhiteText,
            textAlign: 'right',
        },
        mobileStatsGrid: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingTop: 0,
            marginBottom: 14,
            backgroundColor: THEME.OffWhiteGray,
            borderRadius: 4,
        },
        mobileStatItem: {
            flex: 1,
            alignItems: 'center',
            paddingVertical: 5,
        },
        mobileStatLabel: {
            fontSize: 11,
            color: THEME.TextSecondary,
            textTransform: 'uppercase',
            letterSpacing: 0.5,
            marginBottom: 4,
            textAlign: 'center',
        },
        mobileStatValue: {
            fontSize: 14,
            fontWeight: '600',
            color: THEME.Text,
            textAlign: 'center',
        },
    });
};
function PtoBalanceCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const styles = useStyles();
    const mobileStyles = useMobileStyles();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const approverView = props.approverView ?? false;
    const [status, setStatus] = react_1.default.useState(null);
    const [balances, setBalances] = react_1.default.useState(null);
    const [selected, setSelected] = react_1.default.useState(null);
    const [register, setRegister] = react_1.default.useState(null);
    const [timeAndAttendance] = react_1.default.useState(userContext.client?.features?.find((feature) => feature.name === 'time-and-attendance'));
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => TimeAttendance_1.default.getPtoBalances(token, props.employeeId ?? null))).then(data => {
            setBalances(data?.balances);
            setStatus('done');
        }).catch(e => {
            setBalances(null);
            setStatus((e == 404) ? 'done' : 'error');
        });
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => promise.current?.cancel();
    }, []);
    const [expandedItems, setExpandedItems] = react_1.default.useState(new Set());
    const toggleExpanded = (itemName) => {
        const newExpandedItems = new Set(expandedItems);
        if (newExpandedItems.has(itemName)) {
            newExpandedItems.delete(itemName);
        }
        else {
            newExpandedItems.add(itemName);
        }
        setExpandedItems(newExpandedItems);
    };
    return ((0, jsx_runtime_1.jsxs)(Card_1.default, { style: { paddingBottom: 12 }, children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: !!props.employeeId ? t('time:text.ptoBalances') : t('time:text.pto'), style: { marginBottom: 8 } }), size != 'sm' ? ((0, jsx_runtime_1.jsx)(TableHeader_1.default, { columns: [
                    { flex: 3, label: '' },
                    { flex: 2, label: t('time:text.taken'), align: 'flex-end', indent: 8 },
                    { flex: 2, label: t('time:text.remain'), align: 'flex-end', indent: 8 },
                    { flex: 2, label: t('time:text.accrued'), align: 'flex-end', indent: 8 }
                ] })) : null, (0, jsx_runtime_1.jsx)(List_1.default, { data: balances, keyExtractor: (item, index) => item.name, itemSeparator: () => ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [STYLES.separator, { marginVertical: 0 }] })), renderItem: (item, index) => ((0, jsx_runtime_1.jsx)(FadeInView_1.default, { children: size != 'sm' ? ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { disabled: approverView, role: "checkbox", "aria-label": item.name, accessibilityState: { checked: (register == item) }, accessible: true, onPress: () => {
                            if (register == item) {
                                setRegister(null);
                                setSelected(null);
                            }
                            else {
                                setRegister(item);
                                setSelected(item.name);
                            }
                        }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.row, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 3, flexDirection: 'row', alignItems: 'center' }, children: [(!approverView && timeAndAttendance?.isEnabled && !timeAndAttendance?.usesRedirect) &&
                                            (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: (selected == item.name) ? Theme_1.ICONS.Solid.CircleCheck : Theme_1.ICONS.Regular.Circle, color: THEME.Primary, size: 20, style: { marginHorizontal: 8 } })
                                            ||
                                                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { paddingLeft: 8 } }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1, flexDirection: 'column' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: true, "aria-label": item.name, style: [styles.value, { textAlign: 'left' }], children: item.name }), !!item.unlimited ? ((0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: true, "aria-label": item.name, style: [styles.valueSub, { textAlign: 'left' }], children: t('time:text.unlimited') })) : (!isNaN(parseFloat(item.carryover)) && parseFloat(item.carryover) > 0 && ((0, jsx_runtime_1.jsxs)(react_native_1.Text, { accessible: true, "aria-label": t('time:text.carryover'), style: [styles.valueSub, { textAlign: 'left' }], children: [t('time:text.carryover'), ": ", item.carryover || "0", " ", t('time:text.hours')] })))] })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 2, alignItems: 'flex-end', paddingRight: 8 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.Text, { accessible: true, "aria-label": item.taken + t('time:text.hours'), style: styles.value, children: [item.taken, " ", t('time:text.hours')] }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 2, alignItems: 'flex-end', paddingRight: 8 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: true, "aria-label": item.remaining + t('time:text.hours'), style: styles.value, children: !!item.unlimited ? "—" : `${item.remaining} ${t('time:text.hours')}` }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { accessible: true, style: { flex: 2, alignItems: 'flex-end', paddingRight: 8 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: true, "aria-label": item.accrued + t('time:text.hours'), style: styles.value, children: !!item.unlimited ? "—" : !!item.accrued ? `${item.accrued} ${t('time:text.hours')}` : "—" }) })] }, item.name) })) : (
                    // Mobile
                    (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { disabled: approverView, role: "checkbox", "aria-label": item.name, accessibilityState: { checked: (register == item) }, accessible: true, onPress: () => {
                            if (register == item) {
                                setRegister(null);
                                setSelected(null);
                            }
                            else {
                                setRegister(item);
                                setSelected(item.name);
                            }
                        }, style: ({ pressed }) => [
                            {
                                paddingVertical: 0,
                                paddingHorizontal: 12,
                                backgroundColor: pressed ? `${THEME.Black}0F` : 'transparent',
                            }
                        ], children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: mobileStyles.mobilePTONameContainer, children: [(!approverView && timeAndAttendance?.isEnabled && !timeAndAttendance?.usesRedirect) && ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: (selected == item.name) ? Theme_1.ICONS.Solid.CircleCheck : Theme_1.ICONS.Regular.Circle, color: THEME.Primary, size: 15, style: { marginRight: 12 } })), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [styles.value, mobileStyles.mobilePTOName], children: item.name }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            gap: 8
                                                        }, children: [!!item.unlimited ? ((0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [mobileStyles.mobilePTOTagText], children: t('time:text.unlimited') })) : ((0, jsx_runtime_1.jsxs)(react_native_1.Text, { style: mobileStyles.mobilePTOTagText, children: [item.remaining, " ", t('time:text.hours')] })), (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: () => toggleExpanded(item.name), hitSlop: 8, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: expandedItems.has(item.name) ? Theme_1.ICONS.Regular.ChevronUp : Theme_1.ICONS.Regular.ChevronDown, size: 16, color: THEME.Text }) })] })] }) })] }), expandedItems.has(item.name) && ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: mobileStyles.mobileStatsGrid, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: mobileStyles.mobileStatItem, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: mobileStyles.mobileStatLabel, children: t('time:text.taken') }), (0, jsx_runtime_1.jsxs)(react_native_1.Text, { style: mobileStyles.mobileStatValue, children: [item.taken, " ", t('time:text.hours')] })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: mobileStyles.mobileStatItem, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: mobileStyles.mobileStatLabel, children: t('time:text.carryover') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: mobileStyles.mobileStatValue, children: !!item.unlimited ? "—" : `${item.carryover || "0"} ${t('time:text.hours')}` })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: mobileStyles.mobileStatItem, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: mobileStyles.mobileStatLabel, children: t('time:text.accrued') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: mobileStyles.mobileStatValue, children: !!item.unlimited ? "—" : (!!item.accrued ? `${item.accrued} ${t('time:text.hours')}` : "—") })] })] }))] }) })) })), listEmpty: () => (status == 'done')
                    &&
                        (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { alignItems: "center", justifyContent: "center", marginVertical: 16 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.CalendarCircleExclamation, size: 48, color: THEME.ImageNull, style: { marginBottom: 6 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { textAlign: 'center', fontSize: (size != 'sm' ? 16 : 14), color: THEME.TextNull }, children: t('time:text.noPTO') })] })
                    ||
                        (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() }) }), (!approverView && timeAndAttendance?.isEnabled && !timeAndAttendance?.usesRedirect) &&
                (0, jsx_runtime_1.jsx)(Button_1.default, { text: t('time:buttons.request'), textSize: 14, disabled: selected == null || register.enabled == false, onPress: () => props.navigation.navigate('PtoRequest', { registerName: register.name, register: register.register }) })] }));
}
;
